import { Pipe, PipeTransform } from '@angular/core';
import {ReserveModel} from '@app/models/reserve';
import Reserve = ReserveModel.Reserve;

export function getGolferName(r: Reserve) {
    if (notEmpty(r.golferName)) {
        return r.golferName;
    }

    if (notEmpty(r.golferMobile)) {
        return r.golferMobile;
    }

    if (notEmpty(r.userReserve.fname)) {
        return `${r.userReserve.fname} ${r.userReserve.lname}`;
    }

    if (notEmpty(r.userReserve.email)) {
        return r.userReserve.email;
    }

    return r.userReserve.mobile;
}

function notEmpty(s: string) {
    return s && s.length > 1;
}

@Pipe({
  name: 'golferName'
})
export class GolferNamePipe implements PipeTransform {

  transform(reserve: Reserve): unknown {
    return getGolferName(reserve);
  }
}
